// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDkKBy0KDuGLyctJ116Diq5KpfkUo-pVK0",
  authDomain: "healthnichekeywordresearch01.firebaseapp.com",
  projectId: "healthnichekeywordresearch01",
  storageBucket: "healthnichekeywordresearch01.firebasestorage.app",
  messagingSenderId: "708423792491",
  appId: "1:708423792491:web:f0478e3dea4fed63a6fe2e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const auth = getAuth(app);

export default auth;